import React, { useEffect } from 'react';
import { Input, Table, Form, Button, message } from 'antd';

const ImportPreview = ({ data, setData, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ rows: data });
    form.validateFields().catch(() => {});
  }, [data, form]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'name']} rules={[{ required: true, message: 'Please enter the Name' }]}>
          <Input placeholder="Customer Name" />
        </Form.Item>
      ),
    },
    {
      title: 'Contact Person',
      dataIndex: 'contact_Person',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'contact_person']} rules={[{ required: true, message: 'Please enter the Contact Person' }]}>
          <Input placeholder="Contact Person" />
        </Form.Item>
      ),
    },
    {
      title: 'email',
      dataIndex: 'email',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'email']} rules={[{ required: true, message: 'Please enter the Email' },
                              { type: 'email', message: 'Please enter a valid email' }]}>
          <Input placeholder="Customer Email" />
        </Form.Item>
      ),
    },
    {
      title: 'Address',
      dataIndex: 'address',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'address']} rules={[{ required: true, message: 'Please enter the Address' }]}>
          <Input placeholder="Customer Address" />
        </Form.Item>
      ),
    },
    {
      title: 'City',
      dataIndex: 'city',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'city']} rules={[{ required: true, message: 'Please enter the City' }]}>
          <Input placeholder="Customer City" />
        </Form.Item>
      ),
    },
    {
      title: 'State',
      dataIndex: 'state',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'state']} rules={[{ required: true, message: 'Please enter the State' }]}>
          <Input placeholder="Customer State" />
        </Form.Item>
      ),
    },
    {
      title: 'Zip',
      dataIndex: 'zip',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'zip']} rules={[{ required: true, message: 'Please enter the Zip' }]}>
          <Input placeholder="Customer Zip" />
        </Form.Item>
      ),
    },
    {
      title: 'Country',
      dataIndex: 'Country',
      render: (_, __, index) => (
        <Form.Item name={['rows', index, 'country']} rules={[{ required: true, message: 'Please enter the Country' }]}>
          <Input placeholder="Customer Country" />
        </Form.Item>
      ),
    },
  ];

  const handleSubmit = async () => {
    // try {
    //   const values = await form.validateFields();
    //   setData(values.rows);
    //   message.success('Validated. You can now submit.');
    // } catch (err) {
    //   message.error('Please fix errors before submitting.');
    // }
    try {
      const values = await form.validateFields();
      setData(values.rows);
      await onSubmit(values.rows);
    } catch {
      message.error('Please enter valid data before submitting.');
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        size="small"
        rowKey={(record, index) => index}
      />
      <Button type="primary"  className="mt-16" onClick={handleSubmit}>
        Validate & Save Changes
      </Button>
    </Form>
  );
};

export default ImportPreview;
